export default "__VITE_PUBLIC_ASSET__f8458a99__"